<template>
  <div>
    <div
      class="modal show fade modal text-left "
      style="display: block;"
      v-if="show"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title" style="text-transform:capitalize;">
              Update Status
            </h4>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              @click="$emit('hide')"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="card">
              <div class="card-body">
                <div class="col-8" v-show="!showConfirm">
                  <div class="form-group">
                    <label>Status</label>
                    <select  class="form-control" v-model="merchantStatus">
                      <option value="0">Pending Activation</option>
                      <option value="1">Active</option>
                      <option value="2">Inactive</option>
                      <option value="3">Suspended</option>
                      <option value="4">Closed</option>
                    </select>
                  </div>
                </div>
                <div class="col-12" v-show="showConfirm">
                  <div class="text-center">
                    <h2>Are you sure to change the status?</h2>
                  </div>
                  <div class="modal-footer justify-content-between">
                    <button type="button" class="btn btn-gradient-danger" data-dismiss="modal" @click="$emit('hide')">No
                    </button>
                    <button type="button" class="btn btn-gradient-success" @click="sendCall">Yes</button>
                  </div>

                </div>
              </div>

            </div>
          </div>
          <div class="modal-footer justify-content-between">
            <button
              type="button"
              class="btn btn-danger"
              data-dismiss="modal"
              @click="showConfirm = true"
            >
              Update
            </button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="show" class="modal-backdrop fade show"></div>
  </div>
</template>

<script>
export default {
  props: ["show","id","status","row","index","vuexKey"],
  data() {
    return {
      merchantStatus: 0,
      tempStatus:0,
      merchantId: '',
      showModal: false,
      showConfirm: false,
    };
  },
  methods: {
    sendCall(){
      let requestData = {
        id: this.merchantId,
        status: parseInt(this.merchantStatus),
      }
      this.makeRequest('post', 'v1/update-merchant-status', requestData).then(callResponse => {

        if (!callResponse.error) {
          let code = callResponse.response.data.code;
          if (code == 200) {
            this.$emit('hide')
            let data = {
              index: this.index,
              row: this.row,
              key: "merchants"
            };
            data.row.status = parseInt(this.merchantStatus)
            let storeData = this.$store.getters.getByKey(this.vuexKey);
            if (storeData != null) {
              if (typeof storeData.firstPageData != "undefined") {
                if (
                    typeof storeData.firstPageData.data[data.index] != "undefined"
                ) {
                  if (
                      storeData.firstPageData.data[data.index].id == data.row.id
                  ) {
                    storeData.firstPageData.data[data.index] = data.row;
                    delete storeData.otherPageData;
                  }
                }
              }
              if (typeof storeData.otherPageData != "undefined") {
                if (
                    typeof storeData.otherPageData.data[data.index] != "undefined"
                ) {
                  if (
                      storeData.otherPageData.data[data.index].id == data.row.id
                  ) {
                    storeData.otherPageData.data[data.index] = data.row;
                  }
                }
              }
              storeData.key = this.vuexKey;
              this.$store.dispatch("set", storeData);
            }
          }
        }

      });
    }
  },
  watch: {
    status(val) {
      this.merchantStatus = val
      this.tempStatus = this.merchantStatus
    },
    id(val) {
      this.merchantId = val
    },
    show(val) {
      if(!val){
        this.showConfirm = false
        this.merchantStatus = this.tempStatus
      }
      this.showModal = val
    }
  }
};
</script>

<style scoped>
.modal{
  display: block !important; /* I added this to see the modal, you don't need this */
}

/* Important part */
.modal-dialog{
  overflow-y: initial !important
}
.modal-body{
  height: 70vh;
  overflow-y: auto;
}
</style>
